import { connect } from 'react-redux'
import selectors from 'selectors'
import assetCategoryActions from 'actions/assetCategories'
import Component from 'components/Users/Select/Filter'

const mapStateToProps = (state, props) => ({ userGroups: selectors.userGroups.selectOptions(state) })

export default connect(mapStateToProps, { getUserGroups: assetCategoryActions.getOptions })(Component)
